import { Injectable } from '@angular/core';
import {
  JsonPipe,
  DatePipe,
  CurrencyPipe
} from '@angular/common';
import {
  FirestoreTableColumn,
  DxTableColumnTypes
} from './table-definition';
import { NGXLogger } from 'ngx-logger';
import { applyContextToFunctionOrConstant } from '@digitaix/types';

@Injectable({
  providedIn: 'root'
})
export class DisplayService<D, V> {
  constructor(
    public json: JsonPipe,
    public date: DatePipe,
    public currency: CurrencyPipe,
    public logger: NGXLogger
  ) {}

  public toDisplay(value: any, column: FirestoreTableColumn<D, V>, row: D): string {
    if (column.toDisplay) {
      value = applyContextToFunctionOrConstant(column.toDisplay, value, row);
    }
    if (column.type) {
      switch (column.type) {
        case DxTableColumnTypes.DATE:
          return this.date.transform(value, column.format);

        case DxTableColumnTypes.DATETIME:
          return this.date.transform(
            value,
            column.format || 'dd.MM.yyyy HH:mm:ss'
          );

        case DxTableColumnTypes.CURRENCY:
          return this.currency.transform(value, 'â¬');

        case DxTableColumnTypes.JSON:
          return this.json.transform(value);

        case DxTableColumnTypes.CURRENCY_RANGE:
          const range = value || { min: 0, max: 0 };
          return `${this.currency.transform(range.min || 0, 'â¬')} - ${this.currency.transform(range.max || 0, 'â¬')}`;

      }
    }
    let str = '';
    if (typeof value === 'object') {
      if (value) {
        if (value.hasOwnProperty('name')) {
          str = value.name;
        } else if (
          value.hasOwnProperty('vorname') &&
          value.hasOwnProperty('nachname')
        ) {
          str = [ value.vorname, value.nachname ].filter(s => !!s).join(' ');
        } else if (value.hasOwnProperty('toString')) {
          str = value.toString();
        } else {
          str = this.json.transform(value);
        }
      }
    } else if (value === undefined) {
      str = '';
    } else {
      str = value;
    }
    return str;
  }
}
